import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import styles from "components/settings/account-users.scss";
import { Button } from "components/common/button";
import { InviteUserModal } from "components/settings/invite-user-modal";
import { RemoveSelfModal } from "components/settings/remove-self-modal";
import { userType } from "custom-prop-types";

export const AccountUsers = ({
  accountId,
  currentUserId,
  isInviteUserVisible,
  isRemoveSelfVisible,
  newUser,
  onCreateUser,
  onHideInviteUser,
  onHideRemoveSelf,
  onRemoveUser,
  onShowInviteUser,
  onShowRemoveSelf,
  users
}) => {
  const { current, invited } = splitUsers(users);
  return (
    <div>
      <div>
        <h1 className={ styles.title }>Account Users</h1>

        <div className={ styles["invite-button"] }>
          <Button onClick={ onShowInviteUser } primary>Invite User</Button>
        </div>
      </div>

      <div>
        <h2>Current Users:</h2>
        { renderCurrentUsers(current, onRemoveUser, accountId, currentUserId, onShowRemoveSelf) }
        { current.length === 0 && invited.length === 0 ? <h4>No current users.</h4> : null }
      </div>

      <div>
        { renderInvited(invited, onCreateUser, onRemoveUser, accountId) }
      </div>

      <InviteUserModal
        accountId={ accountId }
        isInviteUserVisible={ isInviteUserVisible }
        newUser={ newUser }
        onCreateUser={ onCreateUser }
        onHideInviteUser={ onHideInviteUser }
      />
      <RemoveSelfModal
        accountId={ accountId }
        currentUserId={ currentUserId }
        isRemoveSelfVisible={ isRemoveSelfVisible }
        onHideRemoveSelf={ onHideRemoveSelf }
        onRemoveUser={ onRemoveUser }
      />
    </div>
  );
};

AccountUsers.defaultProps = {
  newUser: null
};

AccountUsers.propTypes = {
  accountId: PropTypes.string.isRequired,
  currentUserId: PropTypes.string.isRequired,
  isInviteUserVisible: PropTypes.bool.isRequired,
  isRemoveSelfVisible: PropTypes.bool.isRequired,
  newUser: userType,
  onCreateUser: PropTypes.func.isRequired,
  onHideInviteUser: PropTypes.func.isRequired,
  onHideRemoveSelf: PropTypes.func.isRequired,
  onRemoveUser: PropTypes.func.isRequired,
  onShowInviteUser: PropTypes.func.isRequired,
  onShowRemoveSelf: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(userType).isRequired
};

const renderInvited = (users, onCreateUser, onRemoveUser, accountId) => {
  if (users.length > 0) {
    return (
      users.map(user => (
        <div key={ user.id }>
          <div>{ user.firstName } { user.lastName }</div>
          <div>
            <small>
              Email: { user.email } &#183; not joined yet &#183;
              <Button link onClick={ () => onCreateUser(accountId, user) }>resend invitation</Button> &#183;
              <Button link onClick={ () => onRemoveUser(accountId, user.id) }>revoke invitation</Button>
            </small>
          </div>
        </div>
      ))
    );
  }
  return null;
};

const renderCurrentUsers = (users, onRemoveUser, accountId, currentUserId, onShowRemoveSelf) => {
  if (users.length > 0) {
    return (
      users.map(user => (
        <div key={ user.id }>
          <div>{ user.firstName } { user.lastName }</div>
          <div>
            <small>
              Email: { user.email } &#183;
              { checkIfSelf(accountId, onRemoveUser, user, currentUserId, onShowRemoveSelf) }
            </small>
          </div>
        </div>
      ))
    );
  }
  return null;
};

const checkIfSelf = (accountId, onRemoveUser, user, currentUserId, onShowRemoveSelf) => {
  if (user.id === currentUserId) {
    return <Button link onClick={ onShowRemoveSelf }>remove self from account</Button>;
  }
  return <Button link onClick={ () => onRemoveUser(accountId, user.id) }>remove user</Button>;
};

const splitUsers = (users) => {
  const { staff, passedUsers } = selectStaff(users);
  const { current, invited } = selectCurrent(passedUsers);
  return { staff, current, invited };
};

const selectStaff = (users) => {
  const staff = users.filter(user => user.staff);
  const passedUsers = R.difference(users, staff);
  return { staff, passedUsers };
};

const selectCurrent = (users) => {
  const current = users.filter(user => user.confirmed);
  const invited = R.difference(users, current);
  return { current, invited };
};



// WEBPACK FOOTER //
// ./src/js/components/settings/account-users.jsx